import { useState, useEffect } from 'react';
import ReactGA from 'react-ga';
import { Tabs } from 'antd';

import './App.css';
import './css/TopMenu.css';
import './css/TopMenuTabColor.css';

import { types, config } from './config/config';
import { gaEvent, fetchContent } from './util/util';
import MenuContent from './component/MenuContent';

const { application, google } = config;

function App() {
  const [fontSize, setFontSize] = useState(14);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [api, setApi] = useState(application.url.prod);
  const [gaId, setGaId] = useState(google.GAId.prod);
  const [contents, setContents] = useState([]);
  const [currentContent, setCurrentContent] = useState('');
  const [currentAudio, setCurrentAudio] = useState(null);
  // const [audioList, setAudioList] = useState([]);
  const [playEvent, setPlayEvent] = useState(null);
  const [pauseEvent, setPauseEvent] = useState(null);
  const [endEvent, setEndEvent] = useState(null);

  const styles = {
    menuParent: {
      minHeight: 800
    },
    content: {
      textAlign: 'center'
    }
  };

  useEffect(() => {
    let apiConfig = application.url.prod;
    let gaIdConfig = google.GAId.prod;

    if (-~(window.location.hostname.indexOf('localhost'))) {
      apiConfig = application.url.local;
      gaIdConfig = google.GAId.local;
    }

    updateModule(0);

    setFontSize(initFontSize());
    setApi(apiConfig);
    setGaId(gaIdConfig);

    ReactGA.initialize(gaIdConfig);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const initFontSize = _ => {
    let oldFontSize = window.localStorage.getItem('fontSize') || 14;

    oldFontSize = parseInt(oldFontSize);
    if (oldFontSize > 70) {
      oldFontSize = 70;
    }
    if (oldFontSize < 14) {
      oldFontSize = 14;
    }
    return oldFontSize
  }

  const updateModule = (index) => {
    var elem = document.querySelectorAll("audio");

    if (elem.length > 0) {
      elem.forEach(el => {
        el.pause();
        el.currentTime = 0;
      })
    }

    composeContent(index);
    // registerAudio(index);

    gaEvent({action: 'menu_click', label: types[index].name});
  }

  const composeContent = async (index) => {
    let currentContent;
    let allContent = [...contents];

    if (contents[index] && currentAudio) {
      currentContent = contents[index];
    } else {
      currentContent = await fetchContent(types[index]);
      if (!currentContent) {
        currentContent = '';
      }

      allContent[index] = currentContent;
    }

    setCurrentIndex(index);
    setCurrentContent(currentContent)
    setContents(allContent);
  }

  const registerAudio = (index) => {
    if (index !== currentIndex) {
      // remove the current event first
      if (currentAudio) {
        currentAudio.removeEventListener('play', playEvent);
        currentAudio.removeEventListener('pause', pauseEvent);
        currentAudio.removeEventListener('ended', endEvent);
      }

      let thisPlayEvent = event => {
        // console.log('play', event.target.id);
        gaEvent({action: 'play', label: event.target.id});
      };

      let thisPauseEvent = event => {
        // console.log('pause', event.target.id);
        gaEvent({action: 'pause', label: event.target.id});
      };

      let thisEndEvent = event => {
        // console.log('ended', event.target.id);
        gaEvent({action: 'ended', label: event.target.id});
      };

      setTimeout(_ => {
        let elem = document.querySelectorAll("audio");

        elem.forEach(el => {
          if (el.id === types[index].name) {
            setCurrentAudio(el);
            setPlayEvent(thisPlayEvent);
            setPauseEvent(thisPauseEvent);
            setEndEvent(thisEndEvent);

            el.addEventListener('play', thisPlayEvent, false);
            el.addEventListener('pause', thisPauseEvent, false);
            el.addEventListener('ended', thisEndEvent, false);
          }
        })
      }, 500);
    }
  }

  const saveFontSize = (add) => {
    let newFontSize = fontSize;

    if (add) {
      newFontSize += 3;
    } else {
      newFontSize -= 3;
    }

    if (newFontSize > 70) {
      newFontSize = 70;
    }
    if (newFontSize > 0) {
      window.localStorage.setItem('fontSize', newFontSize);
    }
    setFontSize(newFontSize);
  };

  const getItems = () => {
    return types.map((type, i) => {
      return {
        key: i,
        label: type.name,
        children: (
          <MenuContent
            type={type}
            currentContent={currentContent}
            saveFontSize={saveFontSize}
            fontSize={fontSize}
          />
        )
      }
    });
  }

  return (
    <div className="App">
      <Tabs
        type="card"
        style={styles.menuParent}
        onChange={updateModule}
        items={ getItems() }
      />
    </div>
  );
}

export default App;